var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5599",
    "data-name": "Group 5599",
    transform: "translate(-534.5 -1519.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_462",
    "data-name": "Ellipse 462",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(535 1520)",
    fill: "#f4f4f4",
    stroke: "#e0e0e0",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5580",
    "data-name": "Group 5580",
    transform: "translate(0 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M32.92,8.133a17.527,17.527,0,0,1,.708,24.036l.018.018,8.248,8.248a1.031,1.031,0,0,1-1.458,1.458l-8.248-8.248-.018-.018a17.527,17.527,0,1,1,.75-25.494ZM9.591,9.591a15.465,15.465,0,1,0,21.87,0A15.465,15.465,0,0,0,9.591,9.591Z",
    transform: "translate(562 1582)",
    fill: "#0c4767",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M33.627,32.17l.018.018,8.248,8.248a1.031,1.031,0,0,1-1.458,1.458L32.17,33.627A10.058,10.058,0,0,1,33.627,32.17Z",
    transform: "translate(562 1582)",
    fill: "#fd9926",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.c1fb892969062250349d96c618fb4fd4.svg";
export { ForwardRef as ReactComponent };